export default __webpack_public_path__ + "static/media/Shadow's Helm of the Swift Return.278b33a3.jpg";